import type { IconPrimitives, IconProps } from './types';

export const buildFieldAppIcons = ({ Svg, Path, Circle, Rect, Ellipse, defaultColor }: IconPrimitives) => ({
  // FieldAppIcons is for core field-app/workflow icons that are not better grouped as utility, extra-needs, or artifacts.
  CameraIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 22.6425 20.4782' fill='none' {...props}>
      <Path
        d='M22.1425 19.9782H0.5V4.8285H5.91062L8.07487 0.5H14.5676L16.7319 4.8285H22.1425V19.9782Z'
        stroke={color}
        strokeMiterlimit={10}
        strokeLinecap='round'
      />
      <Path
        d='M15.6498 14.0266L11.3213 16.7319L6.99278 14.0266V9.15702L11.3213 6.45171L15.6498 9.15702V14.0266Z'
        stroke={color}
        strokeMiterlimit={10}
        strokeLinecap='round'
      />
    </Svg>
  ),
  TasksIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M16.25 3H20.5V22H4.5V3H8.75V2H16.25V3ZM5.5 21H19.5V4H16.25V5.75H8.75V4H5.5V21ZM17.3799 9.3252L11.3799 16.3252L11 16.7686L10.6201 16.3252L7.62012 12.8252L8.37988 12.1748L11 15.2314L16.6201 8.6748L17.3799 9.3252ZM9.75 4.75H15.25V3H9.75V4.75Z'
        fill={color}
      />
    </Svg>
  ),
  NotesIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M20.5 10L20.5 19L4 19L4 5L15 5M20.5 10L15 5M20.5 10L15 10L15 5' stroke={color} />
    </Svg>
  ),
  SettingsIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path
        d='M12 8.75C10.2051 8.75 8.75 10.2051 8.75 12C8.75 13.7949 10.2051 15.25 12 15.25C13.7949 15.25 15.25 13.7949 15.25 12C15.25 10.2051 13.7949 8.75 12 8.75Z'
        stroke={color}
        strokeWidth='1.25'
      />
      <Path
        d='M12 4.5V6.25M12 17.75V19.5M19.5 12H17.75M6.25 12H4.5M17.3033 6.6967L16.0659 7.93414M7.93414 16.0659L6.6967 17.3033M17.3033 17.3033L16.0659 16.0659M7.93414 7.93414L6.6967 6.6967'
        stroke={color}
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  ),
  FieldEditIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M3.5 20L4.24964 14.8559L15.9676 4L20.5 8.3841L8.94788 19.2922L3.5 20Z' stroke={color} />
      <Path d='M12.5391 8L16.5391 12' stroke={color} />
    </Svg>
  ),
  ChangeIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M19.1055 17.5H4.89453L12 5.95312L19.1055 17.5Z' fill={color} stroke={color} />
    </Svg>
  ),
  RemoveIcon: ({ color = defaultColor, size = 24, ...props }: IconProps) => (
    <Svg width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
      <Path d='M8 8L16 16M16 8L8 16' stroke={color} strokeLinejoin='round' />
    </Svg>
  ),
});
